module.exports = __webpack_public_path__ + "img/logo.9ee266dd.svg";